import { createActions } from 'redux-actions';

const {
  toggleContrast,
} = createActions('TOGGLE_CONTRAST');

export function toggleHighContrast() {
  /**
  * No payload is being dispatched since the reducer uses the inverse
  * of the current boolean value already present in state. The reducer
  * simply flips the state to indicate wether or not high contrast should be used.
  */
  return dispatch => dispatch(toggleContrast());
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/settings.js